<script lang="ts">
	import { bookDemo } from '$lib/state/global.svelte';
	import { siteConfig } from '$lib/config/site';
	import { buttonVariants } from '$lib/components/ui/button';
	import { cn } from '$lib/utils.js';
</script>

<div class="mb-16 mt-8 flex flex-col items-center justify-center text-center">
	<h3 class="mb-6 max-w-md text-4xl font-semibold">{siteConfig.endActionsTitle}</h3>
	<div class="flex flex-row gap-x-4">
		<a href={siteConfig.links.signup} rel="noopener noreferrer">
			<div
				class={cn(
					buttonVariants({
						size: 'sm'
						// variant: 'ghost'
					}),
					''
				)}
			>
				<!-- <Icon.Twitter class="size-3 fill-current" /> -->
				<span class="">Start for free</span>
			</div>
		</a>
		<button onclick={bookDemo}>
			<div
				class={cn(
					buttonVariants({
						size: 'sm',
						variant: 'outline'
					}),
					''
				)}
			>
				<!-- <Icon.GitHub class="size-4" /> -->
				<span class="">Talk to sales</span>
			</div>
		</button>
	</div>
</div>
